import Section, { SectionHeading } from '@/components/Section';
import Reveal from '@/components/Reveal';
import { WHY_ITEMS, WHY_IMAGE } from '@/data/content';

export default function WhyGarmond() {
  return (
    <Section id="zasto-garmond" tone="white">
      <div className="grid gap-12 lg:grid-cols-2 lg:gap-20 items-center">
        <Reveal>
          <div className="aspect-[4/3] overflow-hidden bg-sand">
            <img src={WHY_IMAGE.src} alt={WHY_IMAGE.alt} loading="lazy" className="h-full w-full object-cover" />
          </div>
        </Reveal>

        <div>
          <SectionHeading eyebrow="Zašto Garmond" title="Partner za cijeli projekat." />
          <ul className="mt-10 divide-y divide-ink/10 border-y border-ink/10">
            {WHY_ITEMS.map((item) => (
              <li key={item.title} className="py-5">
                <h3 className="text-lg">{item.title}</h3>
                <p className="mt-1 text-ink/70 leading-relaxed">{item.text}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
}
